var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"badge badge-info status",style:({backgroundColor: _vm.getStatusColor(_vm.status)})},[_vm._v("\n    "+_vm._s(_vm.getStatusLabel(_vm.status))+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }